import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CampaignBanner, OpenerScheme, OpenerSchemeStatus, OpenerStrategy, SchemeLocationFilter } from 'src/app/api/api-campaigns.service.generated';
import { GUID } from 'src/app/common/utils/GuidUtils';
import { OpenerSchemeComponent } from '../opener-scheme/opener-scheme.component';
import { ButtonComponent } from "wecheer-common";

@Component({
  selector: 'app-opener-scheme-list',
  templateUrl: './opener-scheme-list.component.html',
  styleUrls: ['./opener-scheme-list.component.scss'],
  imports: [
    MatExpansionModule,
    OpenerSchemeComponent,
    ButtonComponent
]
})
export class OpenerSchemeListComponent implements OnInit, OnChanges {

  @Input() strategy: OpenerStrategy;
  @Input() advertiserId: string;
  @Input() clonedSchemeLocationFilters: SchemeLocationFilter[] = [];

  hideSchemeContent: boolean[] = [];
  schemes: OpenerScheme[] = [];
  isSetFormValueDone = false;
  public savedSchemes: OpenerScheme[] = [];
  public savedLocationFilters: SchemeLocationFilter[] = [];
  public schemeIds: string[] = [];

  constructor() {
  }

  async ngOnChanges() {
    if (!this.isSetFormValueDone) {
      if (this.strategy && (<OpenerStrategy>this.strategy).schemes && (<OpenerStrategy>this.strategy).schemes.length > 0) {
        this.setFormValue((<OpenerStrategy>this.strategy).schemes);
      }
      else {
        this.setFormValue(undefined);
      }
      this.isSetFormValueDone = true;
    }
  }

  async ngOnInit() {
  }

  setFormValue(model: OpenerScheme[]) {
    if (!model || model.length === 0) {
      this.schemes.push(this.getDefaultScheme());
    } else {
      this.schemes = model;
    }
  }

  onAddScheme() {
    this.schemes.push(this.getDefaultScheme());
  }

  private getDefaultScheme(): OpenerScheme {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const nextYear = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate())
    const openerScheme = new OpenerScheme({
      id: GUID.newGuid(),
      name: 'Scheme name',
      status: OpenerSchemeStatus.Active,
      startDate: today,
      endDate: nextYear,
      rewardRules: [],
      banner: new CampaignBanner()
    });
    return openerScheme;
  }

  async onSubmit() {
  }

  toggle(index: string | number) {
    // toggle based on index
    this.hideSchemeContent[index] = !this.hideSchemeContent[index];
  }

  onOpenerSchemeSaved(openerScheme: OpenerScheme) {
    if (this.schemeIds.findIndex(x => x === openerScheme.id) === -1) this.schemeIds.push(openerScheme.id);
    this.savedSchemes[openerScheme.id] = openerScheme;
  }

  onSchemeLocationFilterSaved(schemeLocationFilter: SchemeLocationFilter) {
    this.savedLocationFilters[schemeLocationFilter.schemeId] = schemeLocationFilter;
  }

  onOpenerSchemeRemoved(openerScheme: OpenerScheme) {
    const schemeIndex = this.schemeIds.findIndex(x => x === openerScheme.id);
    if (schemeIndex > 0) {
      this.schemeIds.splice(schemeIndex, 1);
      var newSchemes: OpenerScheme[] = [];
      var newFilters: SchemeLocationFilter[] = [];
      this.schemeIds.forEach((x: any) => {
        newSchemes[x] = this.savedSchemes[x];
        newFilters[x] = this.savedLocationFilters[x];
      });
      this.savedSchemes = newSchemes;
      this.savedLocationFilters = newFilters;
      this.schemes = this.schemes.filter(x => x.id !== openerScheme.id);
    }
  }
}
